export class Prediction {
  static FROM_SERVICE_TYPE = 0;
  static FROM_CNN_TYPE = 1;
  angry?: number;

  disgust?: number;
  disgusted?: number;

  fear?: number;
  fearful?: number;

  happy?: number;
  neutral?: number;
  sad?: number;

  surprise?: number;
  surprised?: number;

  contemptuous?: number;

  static getRoundNumber(num: number): string {
    const precision = 2;
    const multiplier = Math.pow(10, precision || 0);
    const result = (Math.round(num * multiplier) / multiplier) * 100;

    const rounded = Math.round(result);
    if (rounded < 10) {
      return '  ' + rounded.toString();
    } else if (rounded < 100) {
      return ' ' + rounded.toString();
    } else {
      return rounded.toString();
    }
  }

  static getAngryIcon(): string {
    return '\uD83D\uDE20';
  }

  static getDisgustIcon(): string {
    return '\uD83E\uDD22';
  }

  static getFearIcon(): string {
    return '\uD83D\uDE28';
  }

  static getHappyIcon(): string {
    return '\uD83D\uDE00';
  }

  static getNeutralIcon(): string {
    return '\uD83D\uDE10';
  }

  static getSadIcon(): string {
    return '\uD83D\uDE25';
  }

  static getSurpriseIcon(): string {
    return '\uD83D\uDE2E';
  }

  static getContemptuousIcon(): string {
    return '\ud83d\ude0f';
  }

  static getAngryDefaultDescription() {
    return this.getAngryIcon() + ' Angry ';
  }

  static getDisgustDefaultDescription() {
    return this.getDisgustIcon() + ' Disgust ';
  }

  static getFearDefaultDescription() {
    return this.getFearIcon() + ' Fear ';
  }

  static getHappyDefaultDescription() {
    return this.getHappyIcon() + ' Happy ';
  }

  static getNeutralDefaultDescription() {
    return this.getNeutralIcon() + ' Neutral ';
  }

  static getSadDefaultDescription() {
    return this.getSadIcon() + ' Sad ';
  }

  static getSurpriseDefaultDescription() {
    return this.getSurpriseIcon() + ' Surprise ';
  }

  static getContemptuousDefaultDescription() {
    return this.getContemptuousIcon() + ' Contemptuous ';
  }

  static getAngryDefaultDescriptionObject() {
    return {
      icon: this.getAngryIcon(),
      text: ' Angry '
    };
  }

  static getDisgustDefaultDescriptionObject() {
    return {
      icon: this.getDisgustIcon(),
      text: ' Disgust '
    };
  }

  static getFearDefaultDescriptionObject() {
    return {
      icon: this.getFearIcon(),
      text: ' Fear '
    };
  }

  static getHappyDefaultDescriptionObject() {
    return {
      icon: this.getHappyIcon(),
      text: ' Happy '
    };
  }

  static getNeutralDefaultDescriptionObject() {
    return {
      icon: this.getNeutralIcon(),
      text: ' Neutral '
    };
  }

  static getSadDefaultDescriptionObject() {
    return {
      icon: this.getSadIcon(),
      text: ' Sad '
    };
  }

  static getSurpriseDefaultDescriptionObject() {
    return {
      icon: this.getSurpriseIcon(),
      text: ' Surprise '
    };
  }

  static getContemptuousDefaultDescriptionObject() {
    return {
      icon: this.getContemptuousIcon(),
      text: ' Contemptuous '
    };
  }

  constructor(type: number, prediction: any) {
    if (type === Prediction.FROM_SERVICE_TYPE) {
      this.setPredictionsByObject(prediction);
    } else {
      this.setPredictionsByArray(prediction);
    }
  }

  setPredictionsByObject(prediction: object) {
    Object.assign(this, prediction);
  }

  setPredictionsByArray(predictions: number[]) {
    if (predictions.length === 7) {
      this.angry = predictions[0];
      this.disgust = predictions[1];
      this.fear = predictions[2];
      this.happy = predictions[3];
      this.sad = predictions[4];
      this.surprise = predictions[5];
      this.neutral = predictions[6];
    }
  }

  getAngry(): number {
    return this.angry ?? 0;
  }

  getDisgust(): number {
    if (this.disgusted != null) {
      return this.disgusted;
    } else {
      return this.disgust ?? 0;
    }
  }

  getFear(): number {
    if (this.fearful != null) {
      return this.fearful;
    } else {
      return this.fear ?? 0;
    }
  }

  getHappy(): number {
    return this.happy ?? 0;
  }

  getNeutral(): number {
    return this.neutral ?? 0;
  }

  getSad(): number {
    return this.sad ?? 0;
  }

  getSurprise(): number {
    if (this.surprised != null) {
      return this.surprised;
    } else {
      return this.surprise ?? 0;
    }
  }

  getContemptuous(): number {
    return this.contemptuous ?? 0;
  }

  getRoundAngry(): string {
    return Prediction.getRoundNumber(this.getAngry());
  }

  getRoundDisgust() {
    return Prediction.getRoundNumber(this.getDisgust());
  }

  getRoundFear(): string {
    return Prediction.getRoundNumber(this.getFear());
  }

  getRoundHappy(): string {
    return Prediction.getRoundNumber(this.getHappy());
  }

  getRoundNeutral(): string {
    return Prediction.getRoundNumber(this.getNeutral());
  }

  getRoundSad(): string {
    return Prediction.getRoundNumber(this.getSad());
  }

  getRoundSurprise(): string {
    return Prediction.getRoundNumber(this.getSurprise());
  }

  getRoundContemptuous(): string {
    if (this.getContemptuous()) {
      return Prediction.getRoundNumber(this.getContemptuous());
    } else {
      return '  0';
    }
  }

  getAngryMsg(): string {
    return '           ' + Prediction.getAngryIcon() + ' Angry = ' + this.getRoundAngry() + '%';
  }

  getDisgustMsg(): string {
    return '         ' + Prediction.getDisgustIcon() + ' Disgust = ' + this.getRoundDisgust() + '%';
  }

  getFearMsg(): string {
    return '            ' + Prediction.getFearIcon() + ' Fear = ' + this.getRoundFear() + '%';
  }

  getHappyMsg(): string {
    return '           ' + Prediction.getHappyIcon() + ' Happy = ' + this.getRoundHappy() + '%';
  }

  getNeutralMsg(): string {
    return '         ' + Prediction.getNeutralIcon() + ' Neutral = ' + this.getRoundNeutral() + '%';
  }

  getSadMsg(): string {
    return '             ' + Prediction.getSadIcon() + ' Sad = ' + this.getRoundSad() + '%';
  }

  getSurpriseMsg(): string {
    return '        ' + Prediction.getSurpriseIcon() + ' Surprise = ' + this.getRoundSurprise() + '%';
  }

  getContemptuousMsg(): string {
    return '    ' + Prediction.getContemptuousIcon() + ' Contemptuous = ' + this.getRoundContemptuous() + '%';
  }

  getAngryWithIcon(): string {
    return Prediction.getAngryDefaultDescription() + this.getRoundAngry() + ' %';
  }

  getDisgustWithIcon(): string {
    return Prediction.getDisgustDefaultDescription() + this.getRoundDisgust() + ' %';
  }

  getFearWithIcon(): string {
    return Prediction.getFearDefaultDescription() + this.getRoundFear() + ' %';
  }

  getHappyWithIcon(): string {
    return Prediction.getHappyDefaultDescription() + this.getRoundHappy() + ' %';
  }

  getNeutralWithIcon(): string {
    return Prediction.getNeutralDefaultDescription() + this.getRoundNeutral() + ' %';
  }

  getSadWithIcon(): string {
    return Prediction.getSadDefaultDescription() + this.getRoundSad() + ' %';
  }

  getSurpriseWithIcon(): string {
    return Prediction.getSurpriseDefaultDescription() + this.getRoundSurprise() + ' %';
  }

  getContemptuousWithIcon(): string {
    return Prediction.getContemptuousDefaultDescription() + this.getRoundContemptuous() + ' %';
  }

  getMaxEmotionIcon(): object {
    let max = this.getSad();
    let maxEmotion = Prediction.getSadDefaultDescriptionObject();

    if (this.getSurprise() > max) {
      max = this.getSurprise();
      maxEmotion = Prediction.getSurpriseDefaultDescriptionObject();
    }

    if (this.getDisgust() > max) {
      max = this.getDisgust();
      maxEmotion = Prediction.getDisgustDefaultDescriptionObject();
    }

    if (this.getNeutral() > max) {
      max = this.getNeutral();
      maxEmotion = Prediction.getNeutralDefaultDescriptionObject();
    }

    if (this.getHappy() > max) {
      max = this.getHappy();
      maxEmotion = Prediction.getHappyDefaultDescriptionObject();
    }

    if (this.getAngry() > max) {
      max = this.getAngry();
      maxEmotion = Prediction.getAngryDefaultDescriptionObject();
    }

    if (this.getFear() > max) {
      max = this.getFear();
      maxEmotion = Prediction.getFearDefaultDescriptionObject();
    }

    if (this.getContemptuous() > max) {
      // max = this.getContemptuous();
      maxEmotion = Prediction.getContemptuousDefaultDescriptionObject();
    }

    return maxEmotion;
  }

}
